import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, InputGroup, Form } from "react-bootstrap";
import { UsdDonateWrapper } from "./UsdDonateStyle";
import { MESSAGE } from "../../../utils/message";
import { useSelector } from "react-redux";

const UsdDonate = ({ formik }: any) => {
  const availableModules = useSelector((state: any) => state?.modules?.data?.results);
  return (
    <UsdDonateWrapper>
      <Form onSubmit={formik.handleSubmit}>
        <InputGroup>
          <InputGroup.Text className="inputicon">$</InputGroup.Text>

          <Form.Control
            className="inputbox"
            type="number"
            onKeyDown={(evt) => {
              // Prevent entering 'e', 'E', '+', '-', and '0' as the first character
              if (
                ["e", "E", "+", "-"].includes(evt.key)
              ) {
                evt.preventDefault();
              }
            }}
            placeholder="Enter Here"
            id="amount"
            aria-label="Enter Here"
            name="amount"
            value={formik.values.amount}
            onChange={(evt) => {
              // Only update if the first character is not '0'
              const value = evt.target.value;
              if (value === "" || value.match(/^(?!0)\d*$/)) {
                formik.handleChange(evt);
              }
            }}
          />

          <InputGroup.Text className="inputtext">
            {MESSAGE.usd}
          </InputGroup.Text>
        </InputGroup>
        {formik.touched.amount && formik.errors.amount && (
          <div className="error">
            <p>{formik.errors.amount}</p>
          </div>
        )}
        {availableModules?.donation && <Button className="donate-now-btn orange-btn" type="submit">
          {MESSAGE.donateNowBtn}
        </Button>}
      </Form>
    </UsdDonateWrapper>
  );
};

export default UsdDonate;
